import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import pkjson from '../package.json';

//Initialize Sentry instance
Sentry?.init({
  dsn: 'https://69b98279c2f33a406d8f7db651b96182@sentry-relay.penpencil.co/81',
  enabled: true,
  // Adjust this value in production, or use tracesSampler for greater control
  environment: process.env.REACT_APP_NODE_ENV,
  release: pkjson.version,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: true,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry?.browserTracingIntegration(),
    Sentry?.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/pw\.live\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.05, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.05, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
